/* eslint no-restricted-imports: ["error", { patterns: [{
    group: ["*", "!dayjs", "!dayjs/plugin", "!dayjs/plugin/relativeTime", "!dayjs/locale", "!dayjs/locale/en"],
    message: "Please consider the importance of this import, and add exceptions if really necessary"
}]}]
--------
This module is used for landing pages, which need to be very light and minimal on imports. If you
need to change some functionality here, consider looking at lib/utils.ts
*/

// simple helper for toHumanRelativeTimeFromNow below

import dayjs from "dayjs";
import en from "dayjs/locale/en";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

// pass a string date eg. 2019-10-1 and get the difference from present day, in English
// eg. 2019-10-1 => 3 months ago; 2020-6-23 => in 7 months
export function toHumanRelativeTimeFromNow(date: string | Date): string {
  const customLocale = {
    ...en,
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "less than a minute",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years",
    },
  };
  return dayjs(date).locale(customLocale).fromNow();
}

export function toHumanRelativeDateFromNow(date: string | Date): string {
  const dateObj = dayjs(date);
  if (dateObj.isSame(dayjs(), "day")) {
    return "today";
  }

  const customLocale = {
    ...en,
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a day",
      m: "a day",
      mm: "a day",
      h: "a day",
      hh: "a day",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years",
    },
  };

  dateObj.locale(customLocale);

  return dateObj.fromNow();
}
